import { render, staticRenderFns } from "./Persinfo.vue?vue&type=template&id=b1831f80&scoped=true"
import script from "./Persinfo.vue?vue&type=script&lang=js"
export * from "./Persinfo.vue?vue&type=script&lang=js"
import style0 from "./Persinfo.vue?vue&type=style&index=0&id=b1831f80&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1831f80",
  null
  
)

export default component.exports